import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AppService {

  dealers:Observable<any>;
  usersDealers:any = [];

  rooms:Observable<any>;

  public constructor(private afs: AngularFirestore){
    this.init();
  }

  public init(){
    this.dealers = this.afs.collection("dealers", 
                            ref => ref.where("active", "==", true)
                                      .orderBy("online", "desc")
                                      .orderBy("code", "asc")).valueChanges();

    const dealersTemp = this.afs.collection("dealers", 
                                      ref => ref.where("active", "==", true)
                                                .orderBy("online", "desc")
                                                .orderBy("code", "asc")).valueChanges();


    this.rooms = this.afs.collection("chats", 
                            ref => ref.where("type", "==", 'order')
                                      .where("active", "==", true)
                                      .orderBy("updatedAt", "desc")).valueChanges();

    
    dealersTemp.subscribe(data => {
      for (let d of data){
        const aux:any = d;
        this.usersDealers[aux.uid] = d;
      }
    });
  }

    
  getDealers() {
    return this.dealers;
  } 

  getRooms() {
    return this.rooms;
  } 

  getDealerById(uid:string){
    if(uid.indexOf('m-')>=0 || uid.indexOf('b-')){
      uid = uid.substr(2, uid.length);
      console.log("cortando uid", uid);
    }

    console.log(this.usersDealers);
      
    return this.usersDealers[uid];
  }

  async getOrderById(uid: string){
    try{
        let aux = await this.afs.collection("orders", 
            ref => ref.where('uid', '==', uid))
                      .valueChanges().pipe(first()).toPromise().then(doc => {                    	  
                          return doc;
                      }).catch(error => {
                          throw error;
                      });
        if(aux.length==0)
            return {};
        return aux[0];
    }catch(error){
      console.error("Error getOfficeById", error);
      throw error;
    } 
  }
}